
export enum TipoCalificadorEnum {
    NINGUNO = 'NINGUNO',
    DIAS_ACTIVO = 'DIAS_ACTIVO',
    DIAS_TRABAJADOS = 'DIAS_TRABAJADOS',
    HORAS_CODIGO_DE_PAGO = 'HORAS_CODIGO_DE_PAGO',
    DIAS_COMO_EMPLEADO = 'DIAS_COMO_EMPLEADO'
}